import SkinnyBanner from './SkinnyBanner.vue'

export default SkinnyBanner
